import { Heading } from '@rebass/emotion';
import Button from '../Button';
import { ProductsResult } from './ProductsProvider';

interface InputProps {
  products?: DeepOmit<ProductsResult, '__typename'>;
}

const ErrorContent = ({ products }: InputProps): JSX.Element => {
  const retryButton = (
    // @ts-expect-error TODO add typing to Button component
    <Button
      onClick={() => products?.refetch()}
      data-testid="product-finder-try-again-button"
    >
      Try again
    </Button>
  );

  return (
    <Heading
      pt={4}
      pb={4}
      textAlign="center"
      data-testid="product-finder-error-message"
    >
      Oops! We seem to be having trouble completing your request.
      <br />
      Please try again in a moment.
      <br />
      <br />
      {typeof products !== 'undefined' && retryButton}
    </Heading>
  );
};

export default ErrorContent;
